import React from "react";
import EventMarketButton from "../../events/EventMarketButton";
import {
  BookmakerRunnerDTO,
  BookmakerDTO,
  EventDTO,
  useAppDispatch,
  PlaceBetRequest,
  addExchangeBet,
  useAppSelector,
  showToast,
  oneClickBetPlaceHandler,
  setAlertMsg,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
} from "@hypexone/uicore";
import moment from "moment";

interface BookmakerBackAndLayProps {
  runner: BookmakerRunnerDTO;
  market: BookmakerDTO;
  eventData: EventDTO;
  oddType: "back-odd" | "lay-odd";
  disabledStatus: string[];
}

const BookmakerBackAndLay: React.FC<BookmakerBackAndLayProps> = ({
  runner,
  market,
  eventData,
  oddType,
  disabledStatus,
}) => {
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { isOneClickBettingEnabled, isOneClickBettingLoading } = useAppSelector(
    (state) => state.betSlip
  );
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const isBackOdd = oddType === "back-odd";

  return (
    <EventMarketButton
      mainValue={
        disabledStatus.includes(market.status?.toLowerCase()) ||
        disabledStatus.includes(runner.status?.toLowerCase()) ||
        eventData?.eventSuspended === true ||
        market.suspend === true
          ? 0
          : isBackOdd
          ? runner.backPrice
          : runner.layPrice
      }
      subValue={Number(isBackOdd ? runner.backSize : runner.laySize)}
      oddType={oddType}
      valueType="bookmakerOdds"
      showSubValueinKformat={true}
      disable={
        disabledStatus.includes(
          market.status?.toLowerCase()
        ) ||
        disabledStatus.includes(
          runner.status?.toLowerCase()
        ) ||
        eventData?.eventSuspended === true ||
        market.suspend ||
        market.disable
      }
      onClick={() => {
        if (isOneClickBettingLoading) {
          dispatch(
            showToast({
              type: "error",
              message: langData?.["betIsInProgress"],
            })
          );
          return;
        }

        if (
          disabledStatus.includes(market.status?.toLowerCase()) ||
          disabledStatus.includes(runner.status?.toLowerCase()) ||
          eventData?.eventSuspended === true ||
          market.suspend ||
          market.disable
        ) {
          return;
        }
        const betData: PlaceBetRequest = {
          sportId: eventData?.sportId,
          seriesId: eventData?.competitionId,
          seriesName: eventData?.competitionName,
          eventId: eventData?.eventId,
          eventName: eventData?.eventName,
          eventDate: eventData?.openDate,
          marketId: market.marketId,
          marketName: market.marketName,
          marketType: "BM",
          outcomeId: runner.runnerId,
          outcomeDesc: runner.runnerName,
          betType: isBackOdd ? "BACK" : "LAY",
          amount: 0,
          oddValue: Number(isBackOdd ? runner.backPrice : runner.layPrice),
          sessionPrice: -1,
          oddLimt: market?.marketLimits?.maxOdd?.toString(),
          minStake:
            (market?.marketLimits?.minStake ?? 0) / cFactor,
          maxStake:
            (market?.marketLimits?.maxStake ?? 0) / cFactor,
          mcategory: "ALL",
          oddType: market.oddType,
        };
        // if (
        //   market?.marketName?.toUpperCase() === "TOSS" &&
        //   Number(isBackOdd ? runner.backPrice : runner.layPrice) > 0
        // ) {
        //   betData["displayOddValue"] = TOSS_ODD_VALUE;
        // }

        if (isOneClickBettingEnabled) {
          dispatch(addExchangeBet(betData));
          dispatch(
            oneClickBetPlaceHandler({
              bets: [
                {
                  ...betData,
                  delay: market?.marketLimits?.delay,
                },
              ],
              langData,
              setAlertMsg,
              eventData,
            })
          );
        } else {
          dispatch(addExchangeBet(betData));
        }
      }}
    />
  );
};

export default BookmakerBackAndLay;
